import { render, staticRenderFns } from "./VersionComponent.vue?vue&type=template&id=394faccd&scoped=true"
import script from "./VersionComponent.vue?vue&type=script&lang=ts"
export * from "./VersionComponent.vue?vue&type=script&lang=ts"
import style0 from "./VersionComponent.vue?vue&type=style&index=0&id=394faccd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394faccd",
  null
  
)

export default component.exports